import { CON_SOURCE } from "@constants/inbound";

export const ConSourceCell = ({ data }: any) => {
  const parameterName = "conSource";
  if (!data.data[parameterName]) return null;

  const labelColor = () => {
    switch (data.data[parameterName].code) {
      case CON_SOURCE.COMPANY:
        return "inline-block p-1.5 font-medium text-white bg-gray-500 rounded";
      case CON_SOURCE.FARMMORNING:
        return "inline-block p-1.5 font-medium text-white bg-green-400 rounded";
    }
  };

  return (
    <>
      <button disabled={true} className={labelColor()}>
        {data.data[parameterName].value}
      </button>
    </>
  );
};

export default ConSourceCell;
